'use client'

import React from 'react'
import { sidebarStore } from '@/store/ui/sidebar.store'
import { useRouter } from 'next/navigation'
import { homeActionLog } from '@/modules/action-log/home'

export const HosooHeader = () => {
  const { changeVisible } = sidebarStore()
  const router = useRouter()

  const handleClickOpenMenu = () => {
    homeActionLog.clickMenu()
    changeVisible({ visible: true })
  }

  const handleClickHome = () => {
    router.push('/hosoo')
  }

  return (
    <div className="bg-purple-2 flex justify-between items-center sticky top-0 z-20 h-[56px] w-[100%] pt-[20px] pb-[20px] pl-[16px] pr-[16px]">
      <button className="flex items-center gap-[2px]" onClick={handleClickHome}>
        <img src="/img/logo.svg" />
        <img src="/img/close_thin.svg" />
        <img className="w-[80px] h-[28px]" src="/img/entertainment/namex_logo.png" />
      </button>
      <button className="cursor-pointer" onClick={handleClickOpenMenu}>
        <img src="/img/menu.svg" />
      </button>
    </div>
  )
}
